import QRCode from 'qrcode';
import type { StudentKP, PlayerProgress } from '../../shared/types';

interface SyncPayload {
  v: 1;
  kps: StudentKP[];
}

export async function encodeKPsAsQR(kps: StudentKP[]): Promise<string> {
  const payload: SyncPayload = { v: 1, kps };
  const json = JSON.stringify(payload);
  // qrcode toDataURL returns a data:image/png;base64 URL
  return QRCode.toDataURL(json, { errorCorrectionLevel: 'M', width: 320 });
}

export function importKPsFromPayload(progress: PlayerProgress, payloadJson: string): { merged: number } {
  const payload = JSON.parse(payloadJson) as SyncPayload;
  if (payload.v !== 1) throw new Error('Unknown sync payload version');
  if (!progress.studentKPs) progress.studentKPs = [];
  let merged = 0;
  for (const incoming of payload.kps) {
    const existing = progress.studentKPs.find(k => k.kpId === incoming.kpId);
    if (existing) {
      // Merge: take the more advanced state (later lastReviewedISO wins)
      if (incoming.lastReviewedISO > existing.lastReviewedISO) {
        Object.assign(existing, incoming);
        merged++;
      }
    } else {
      progress.studentKPs.push(incoming);
      merged++;
    }
  }
  return { merged };
}
